import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=557323f0&scoped=true"
import script from "./certification.vue?vue&type=script&lang=js"
export * from "./certification.vue?vue&type=script&lang=js"
import style0 from "./certification.vue?vue&type=style&index=0&id=557323f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557323f0",
  null
  
)

export default component.exports